import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getSlsInventoryStatus } from './apis'
import { GetSlsInventoryStatusReq, SlsInventoryStatus } from './types'

const PATH = ['inventory', 'slsInventoryStatus'] as const

export const slsInventoryStatusQueryKeys = {
  all: PATH,
  detail: (params: GetSlsInventoryStatusReq) => [...PATH, 'DETAIL', params] as const,
}

/**
 * SLS 실시간 재고 조회.
 *
 * 진입 즉시 조회하지 않는다(`enabled: false`) — 바코드·화주코드가 필수라 빈 조건으로 부르면 400 이다.
 * 캐시를 두지 않는다(`staleTime: 0`, `gcTime: 0`). 이 화면의 용도가 "지금 SLS 에 뭐가 있나" 확인이라
 * 같은 조건 재조회에 이전 응답을 돌려주면 도구의 목적이 사라진다.
 */
export const useGetSlsInventoryStatus = (params: GetSlsInventoryStatusReq): UseQueryResult<SlsInventoryStatus, Error> =>
  useQuery({
    queryKey: slsInventoryStatusQueryKeys.detail(params),
    queryFn: async () => (await getSlsInventoryStatus(params)).data,
    enabled: false,
    staleTime: 0,
    gcTime: 0,
  })
